import { Factory } from '../../services/Factory';

namespace app.directives.charting {
  export class RowChart implements angular.IDirective {
    public restrict: string = "E";
    public link: (scope, element: angular.IAugmentedJQuery, attrs) => void;
    public template: string;
    public scope = {data: "=ngModel", animation: "="};
    public require = ["ngModel"];

    constructor(private $timeout: any, private $rootScope: any) {
      this.template = `<div></div>`;
      this.link = (scope, element: angular.IAugmentedJQuery, attrs) => {
        const chart = c3.generate({
          bindto: element[0],
          size: {
            height: scope.height ? +scope.height : 460,
            width: +scope.width
          },
          padding: {
            top: 20,
            bottom: 20,
            left: 20,
            right: 20
          },
          data: {
            x: "x",
            columns: [
              ["x", ...scope.data.map(d => d.value.key ? d.value.key : d.key)],
              ['y', ...scope.data.map(d => d.value.value ? d.value.value : d.value)],
            ],
            type: "bar",
            labels: {
              format: (v, id, i, j) => {
                if (i >= 0) {
                  const d = scope.data[i];
                  return d.value.key ? d.value.key : d.key;
                }

                return "";
              }
            },
            color: (color, d: any) => Theme.Colors[d.index],
            empty: {
              label: {
                text: "No Data"
              }
            },
            onclick: e => {
              scope.$emit("chartItemSelected", element, {
                id: scope.data[e.index].id ?? scope.data[e.index].key,
                type: scope.data[e.index].type
              });
            }
          },
          bar: {
            width: 20
          },
          transition: {
            duration: scope.animation === false ? 0 : 1500
          },
          legend: {
            show: false
          },
          tooltip: {
            show: false
          },
          axis: {
            rotated: true,
            x: {
              type: "category",
              show: false
            },
            y: {
              show: true
            }
          }
        });

        scope.$watch("data", data => {
          if (data.length === 0) {
            chart.unload();

            return;
          }

          chart.load({
            columns: [
              ["x", ...scope.data.map(d => d.value.key ?? d.key)],
              ["y", ...scope.data.map(d => d.value.value ?? d.value)],
            ]
          });
        });
      }
    }
  }

  frontendApp.directive("iioRowChart", ["$timeout", "$rootScope", Factory.Create(RowChart)]);
}
